/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InvoicePaymentEmailPathParams, InvoicePaymentEmailResponse } from '../types/InvoicePaymentEmail'

/**
 * POST /:organisation/invoices/:invoice/payments/:payment/send-email
 * @see backend/nexus/modules/Billing/Http/Controllers/InvoicePaymentController.php InvoicePaymentController::email
 */
export async function invoicePaymentEmail(
	organisation: InvoicePaymentEmailPathParams['organisation'],
	invoice: InvoicePaymentEmailPathParams['invoice'],
	payment: InvoicePaymentEmailPathParams['payment'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InvoicePaymentEmailResponse>> {
	return axiosInstance.post(`/${organisation}/invoices/${invoice}/payments/${payment}/send-email`, undefined, config)
}
